<div class="innerpage-fullwithbanner">
  <h2 class="bighead">Marketing Attribution Dashboard</h2>
  <ul class="bread-crumbs">
    <li><a>Home<span>|</span></a></li>
    <li>Opportunity<span style="padding:8px;">|</span></li>
    <li>Marketing Attribution Dashboard</li>
  </ul>
</div>
<div class="section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="row">
       <div class="col-md-12">
         <div class="border-div table-fixed margin-bottom-0">
           <div>
             <div class="d-flex be-m-a-filter" style="justify-content: end; -webkit-justify-content: flex-end;align-items: flex-end;-webkit-align-items: flex-end;">
               <div class="d-flex">
                 <label class="select margin-right-10">
                   <select class="form-control" [(ngModel)]="selectedAction" (change)="onUTMACtionSelect();" style="width:175px">
                     <option value="All">All</option>
                     <option *ngFor="let action of actionList" value="{{action.Action}}" [selected]="action == selectedAction">{{action.Action}}</option>
                   </select>
                   <i></i>
                 </label>
                 <label class="select">
                   <select class="form-control" [(ngModel)]="selectedValue" (change)="onActionSelect();" style="width:175px">
                     <option value="3">Last 3 Months</option>
                     <option value="6">Last 6 Months</option>
                     <option value="11">Last 1 Year</option>
                   </select>
                   <i></i>
                 </label>

                 <ul class="filter-section">
                   <li [class.active]="activetab === 'Chart'" (click)="onViewChange(1)">
                     <a>
                       <i class="icon-analytics icon"></i>
                     </a>
                   </li>
                   <li [class.active]="activetab !== 'Chart'" (click)="onViewChange(2)">
                     <a>
                       <i class="icon-grid-icon icon"></i>
                     </a>
                   </li>
                 </ul>
               </div>
             </div>
             
             <div class="cf">
               <div>
                 <div class="row graph">
                   <div class="col-md-12">
                     <div class="table-fixed  margin-bottom-0">
                       <div class="floatinghead clearfix">
                         <div id="container" *ngIf="activetab==='Chart'"></div>
                         <div class="markettingTable" *ngIf="activetab!=='Chart'">
                           <div class="table-responsive">
                             <table class="table basictable row-border hover">
                               <thead>
                                 <tr>
                                   <th>UTM Souce</th>
                                   <th *ngFor="let yearlyUser of monthList;let i = index"> {{ yearlyUser }}</th>
                                 </tr>
                               </thead>
                               <tbody>
                                 <ng-container *ngFor="let data of utmSouceList;let j = index1">
                                   <tr>
                                     <td>
                                       <p class="d-flex">
                                         <span (click)="showMonthlyCount(data,j)" class="btn-collapse" [class.span-open]="data.ShowMonthlyData">
                                           <i class="fa fa-angle-right" aria-hidden="true"></i>
                                         </span>
                                         {{ data.UtmSource }}
                                     </td>
                                     <td *ngFor="let newd of monthList;let k = index">
                                       <span>{{GetMonthlyTotal(newd,data.UtmSource)}}</span>
                                     </td>
                                   </tr>
                                   <ng-container *ngIf="data.ShowMonthlyData">
                                     <ng-container *ngFor="let month1 of tableactionList;let i = index">
                                       <tr class="tr-sub">
                                         <td>
                                           {{month1}}
                                         </td>
                                         <td *ngFor="let newd of monthList;let k = index">
                                           <span>{{GetActionMonthlyTotal(data,newd,month1)}}</span>
                                         </td>
                                       </tr>

                                     </ng-container>
                                   </ng-container>
                                 </ng-container>
                               </tbody>
                               <tfoot>
                                 <tr *ngIf="utmSouceList?.length == 0 && monthcount>0">
                                   <td [attr.colspan]="monthcount" class="odd no-data-available">
                                     <div class="nodata">
                                       <i class="fa fa-exclamation-triangle icon"></i>
                                       <p>No Data Available</p>
                                     </div>
                                   </td>
                                 </tr>
                               </tfoot>
                             </table>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
    </div>
   
    </div>
  </div>



